export const themes = (offerId: string | undefined, cartId: string | undefined, orderId: string | undefined, locationId: string | undefined, region: string | undefined) =>
  ['themes', offerId, cartId, orderId, locationId, region] as const

export const themesV2 = (offerId: string | undefined, cartId: string | undefined, orderId: string | undefined, locationIds: Array<string> | undefined, region: string | undefined) =>
  ['themesV2', offerId, cartId, orderId, locationIds, region] as const
